import { Tabs, TabList, Tab, TabPanel, Card } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";
import { css } from "@emotion/css";
import { useState, useEffect } from "react";
import { useQueryParams } from "@certn/api";
import { Email } from "./Email";
import { DesktopMenu } from "./DesktopMenu";
import { MobileMenu } from "./MobileMenu";
import { Favicon } from "./Favicon";

const VALID_TAB_IDS = [
  "email",
  "desktop-menu",
  "mobile-menu",
  "favicon",
] as const;
const DEFAULT_TAB = "email";

export function BrandingPreview() {
  const { t } = useTranslation();
  const { params, setParam } = useQueryParams();

  const tabParam = Array.isArray(params.tab) ? params.tab[0] : params.tab;
  const initialTab =
    tabParam && VALID_TAB_IDS.includes(tabParam as any)
      ? tabParam
      : DEFAULT_TAB;
  const [activeTab, setActiveTab] = useState<string>(initialTab);

  const handleTabChange = (key: React.Key) => {
    const tabId = key as string;
    setActiveTab(tabId);
    setParam("tab", tabId);
  };

  useEffect(() => {
    const currentTabParam = Array.isArray(params.tab)
      ? params.tab[0]
      : params.tab;
    if (
      currentTabParam &&
      VALID_TAB_IDS.includes(currentTabParam as any) &&
      currentTabParam !== activeTab
    ) {
      setActiveTab(currentTabParam);
    }
  }, [params.tab, activeTab]);

  return (
    <Card className={css(styles.card)} type="large">
      <Tabs
        testID="branding-preview-tabs"
        orientation="horizontal"
        selectedKey={activeTab}
        onSelectionChange={handleTabChange}
        gap="space-3"
      >
        <TabList aria-label={t("Branding sections")} className={styles.tabs}>
          <Tab id="email" testID="branding-tab-email">
            {t("Email")}
          </Tab>
          <Tab id="desktop-menu" testID="branding-tab-desktop-menu">
            {t("Desktop menu")}
          </Tab>
          <Tab id="mobile-menu" testID="branding-tab-mobile-menu">
            {t("Mobile menu")}
          </Tab>
          <Tab id="favicon" testID="branding-tab-favicon">
            {t("Favicon")}
          </Tab>
        </TabList>
        <TabPanel id="email" className={styles.tabPanel}>
          <Email />
        </TabPanel>
        <TabPanel id="desktop-menu" className={styles.tabPanel}>
          <DesktopMenu />
        </TabPanel>
        <TabPanel id="mobile-menu" className={styles.tabPanel}>
          <MobileMenu />
        </TabPanel>
        <TabPanel id="favicon" className={styles.tabPanel}>
          <Favicon />
        </TabPanel>
      </Tabs>
    </Card>
  );
}

const styles = {
  card: css({
    flex: 1,
    overflow: "hidden",
  }),
  tabs: css({
    marginRight: "var(--space-4)",
    marginLeft: "var(--space-4)",
    paddingTop: "var(--space-3)",
  }),
  tabPanel: css({
    backgroundColor: "var(--background-accent-neutral-weak)",
    padding: "var(--space-5)",
    margin: 1,
  }),
};
